import * as EventsConstants from '../constants';

const initialState = {
  collection: [],
  isFetching: false,
  closingEvents: [],
  sorting: {
    sort: 'desc',
    order: 'created_at',
    query: ''
  },
  pagination: {
    total: 0,
    perPage: 10,
    totalPages: 0,
    page: 0
  }
};

export function triggerAdherenceEvents(state = initialState, action) {
  switch (action.type) {
    case EventsConstants.ADHERENCE_EVENTS_FETCH_STARTED:
      return {...state, isFetching: true};
    case EventsConstants.ADHERENCE_EVENTS_FETCH_COMPLETED:
      return {
        ...state,
        collection: action.events,
        pagination: action.pagination,
        sorting: action.sorting,
        isFetching: false
      };
    default:
      return state;
  }
}
